import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import tw from "tailwind-styled-components";

const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;

const ToastContainer = styled.div`
  position: fixed;
  right: 1vw;
  top: max(3.55rem + 10px, 8vh);
  z-index: 9999;
`;

const Toast = tw.div`
bg-white p-3 border border-solid border-gray-300 rounded-lg shadow-lg
`;

const ServiceWorkerUpdateService = () => {
  const [newVersion, setNewVersion] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    let lastVersion = null;

    const onSwMessage = (event) => {
      if (event.data && event.data.type === "VERSION") {
        const swVersion = event.data.version;

        if (lastVersion === null) {
          lastVersion = swVersion;
          console.log("[humans] SW last version set to", swVersion);
        } else if (lastVersion !== swVersion) {
          console.log("[humans] SW was updated, new version is", swVersion);
          setNewVersion(true);
        }
      }
    };
    navigator.serviceWorker.addEventListener("message", onSwMessage);

    const checkUpdate = () => {
      navigator.serviceWorker
        .getRegistration(swUrl)
        .then((reg) => {
          if (reg) {
            // Check if registration is still valid before using it
            try {
              reg.update().catch((error) => {
                // Ignore errors about uninstalled registrations or invalid objects - this is normal during transitions
                if (
                  !error.message.includes("uninstalled") &&
                  !error.message.includes("no longer") &&
                  !error.message.includes("not, or is no longer")
                ) {
                  console.error("[SW] Error during update check:", error);
                }
              });
              setTimeout(() => {
                // Check if registration and active worker are still valid
                try {
                  if (reg && reg.active && reg.active.state !== "redundant") {
                    reg.active.postMessage({ type: "GET_VERSION" });
                  }
                } catch {
                  // Registration or worker is no longer valid, ignore
                }
              }, 100);
            } catch {
              // Registration object is invalid, ignore
            }
          } else {
            // No registration found, try to register
            navigator.serviceWorker.register(swUrl).catch((error) => {
              console.error("[SW] Error registering service worker:", error);
            });
          }
        })
        .catch((error) => {
          // Ignore errors when getting registration
          if (
            !error.message.includes("uninstalled") &&
            !error.message.includes("no longer")
          ) {
            console.error("[SW] Error getting registration:", error);
          }
        });
    };

    checkUpdate();
    let intervalId = setInterval(checkUpdate, 1000 * 60 * 5);

    return () => {
      navigator.serviceWorker.removeEventListener("message", onSwMessage);
      clearTimeout(intervalId);
    };
  }, []);

  const onRefresh = useCallback((e) => {
    e.preventDefault();
    window.location.reload();
  }, []);

  if (!newVersion) {
    return null;
  }

  return (
    <ToastContainer>
      <Toast>
        A new app version is available{" "}
        <a
          className="text-blue-500 hover:text-blue-600"
          href="/"
          onClick={onRefresh}
        >
          Refresh
        </a>
      </Toast>
    </ToastContainer>
  );
};

export default ServiceWorkerUpdateService;
